// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__32fWQ","footer":"ReportModalFilter_footer__3_9oG"};